import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

/**
 * Firebase config comes from build-time env vars (REACT_APP_FIREBASE_*),
 * never hard-coded. This is the web SDK config — it is not a secret;
 * Firebase security is enforced by Firestore rules, not by hiding
 * these values. See .env.example.
 *
 * `.env.local` (gitignored) holds the real values locally; the same
 * variables are set in the GitHub Pages deploy step.
 */
const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

/* True once real keys are present. Every consumer of Firestore/Auth
   checks this first and falls back to a clear "not connected" state
   rather than throwing — the site must still work, and not silently
   pretend to save data, before the backend is wired up. */
export const isFirebaseConfigured = Boolean(
  config.apiKey && config.projectId && config.appId
);

let app = null;
let dbInstance = null;
let authInstance = null;

if (isFirebaseConfigured) {
  app = getApps().length ? getApps()[0] : initializeApp(config);
  dbInstance = getFirestore(app);
  authInstance = getAuth(app);
} else if (process.env.NODE_ENV !== "production") {
  // eslint-disable-next-line no-console
  console.warn(
    "[firebase] Not configured — REACT_APP_FIREBASE_* env vars are missing. " +
      "Testimonials, the blog admin panel and site-settings editing are disabled " +
      "until they are set. See .env.example."
  );
}

export const db = dbInstance;
export const auth = authInstance;
